// Bundled, content-hashed font URLs (1-year immutable cache on the host).
import oswald from "@/assets/fonts/oswald-latin.woff2?url";
import sourceSans from "@/assets/fonts/source-sans-3-latin.woff2?url";
export const OSWALD_FONT_URL = oswald;
export const SOURCE_SANS_FONT_URL = sourceSans;
